import * as z from "zod/v4";

export const generateProductBarcode = {
  name: "generateProductBarcode" as const,
  input: z.object({}),
  output: z.object({ barcode: z.string() }),
};
